import { types } from "../../types/types";

const initialState = {
  items: [],
  loading: false
};

export const abmMaterialesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmMaterialesTraerStart:
      return {
        ...state,
        loading: true,
        items: []
      };
    case types.abmMaterialesTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload
      };
    case types.abmMaterialesTraerError:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
